import {
  NAVIGATION_RESET_ALL,
  NAVIGATION_SET_DRAWER,
} from '../mutation-types';


// state
const localState = {
  drawer: true,
};

// mutations
const mutations = {
  [NAVIGATION_RESET_ALL](state) {
    Object.assign(state, localState());
  },
  [NAVIGATION_SET_DRAWER](state, drawer) {
    state.drawer = drawer;
  },
};

// actions
const actions = {

};

export default {
  state: localState,
  mutations,
  actions,
};
